import useFormContext from "./useFormContext.js"
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import * as L from 'leaflet';
import '../ResponsiveEvent.jsx/FamilyEvent.css';
import './RequestHeader.css';
import { SITES_BASE_URL, SITE_DETAILS_URL } from "../ApiDetails.js";
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import { FaTrash,FaSearch } from 'react-icons/fa';
import Popup from 'reactjs-popup';
import Logo from '../../logo.png';

const FamilyEvent = () => {
  const { eventFormData, setEventFormData, handleChange, errors, fetchEventTypes,
    fetchEventFormat, fetchLastVisit, fetchAssociateAtEvent, fetchCountry, fetchPhonecode,
    eventTypeList, eventFormatList, lastVisitList, phoneCodeList, nonEditable,
    handleNonEditableUI, fetchUsers, suggestion, selectSuggestionValue,
    toggleAssociatesCheckbox, associateAtEventChecked,
    fetchSiteCodes, siteCodelist, handleEmailValidation,
    searchAddress, setSearchAddress,
    isEventOffSite, setIsEventOffSite,
    fetchfamilyUsers, familyUsers
  } = useFormContext();

  const [btnSetReqVisible, setBtnSetReqVisible] = useState(false);
  const [newRequestorId, setNewRequestorId] = useState(null);
  const [userSearch, setUserSearch] = useState("");

  const [isPersonalTravel, setIsPersonalTravel] = useState(false);
  const [personalTravelComment, setPersonalTravelComment] = useState("");
  const [eventPersons, setEventPersons] = useState([
      {userId:66,userFullName:"Alexi Kobisch-Miana",personType:"Requestor"},
      {userId:-1,userFullName:"Lucien Kobisch-Miana",personType:"Other"},
      {userId:1,userFullName:"Christa Schmidt",personType:"Family"},
  ]);
  const [rationale, setRationale] = useState("");
  
  const eventPlaceDefault = {siteCode:"", eventAddress:"", isExternal:false, externalAddress:"", totalAttendees:null};
  const [eventPlaces, setEventPlaces] = useState([eventPlaceDefault]);
/*
  const [eventPlaces, setEventPlaces] = useState([
      {siteCode:"ABJ", eventAddress:"", isExternal:false, externalAddress:"", totalAttendees:null},
      {siteCode:"ACA", eventAddress:"", isExternal:false, externalAddress:"", totalAttendees:null},
      {siteCode:"OFF", eventAddress:"", isExternal:true, externalAddress:"12 rue du trompette", totalAttendees:null},
      ]);
*/

  const capacities = ["Director","Advisor","Family Member","Consultant"];
  const [requestorCapacities, setRequestorCapacities] = useState([false,false,false,false]);
  const [testBool, setTestBool] = useState(false);

  const [showReqModal, setShowReqModal] = useState(false);


  const [mapMarker, setMapMarker] = useState(null);
  const leafLetMap = useRef(null);
  const [timer, setTimer] = useState(null);


  if (nonEditable) {
    handleNonEditableUI()
  }

  const isFirstRender = useRef(true);
  const storedRole = localStorage.getItem('role');

  const [siteData, setSiteData] = useState([]);
  const fetchSiteData = async () => {
    try {
      const response = await axios.get(SITE_DETAILS_URL);

      const tSiteData = response.data
          .map((site) => ({
          siteCode: site.site_code,
          name: (site.site_code + " - " + (site.unit!=="" ? site.unit : "Offsite events")) || "Unknown",
          lat: site.latitude ? parseFloat(site.latitude) : null,
          lng: site.longitude ? parseFloat(site.longitude) : null,
          }))
          .sort((a, b) => a.name.localeCompare(b.name));

      setSiteData(tSiteData);
    } catch (error) {
      console.error("Error fetching site list data:", error);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      const role = localStorage.getItem('role');
      if (role==="Admin") setBtnSetReqVisible(true);
      fetchAssociateAtEvent();
      loadInitMap();
      fetchfamilyUsers();
      fetchEventTypes();
      fetchEventFormat();
      fetchLastVisit();
      fetchUsers();
      fetchSiteCodes();
      fetchSiteData();
      fetchCountry();
      fetchPhonecode();

      isFirstRender.current = false;
    }
  }, [eventFormData]);

  const associateMapping = {
    "Corporate": "marsCorporateAttendees",
    "Food & Nutrition & Multisales": "marsFoodNutritionAttendees",
    "Mars Global Services": "marsGlobalServicesAttendees",
    "Multisales": "marsMultisalesAttendees",
    "Snacking": "marsSnackingAttendees",
    "Petcare": "marPetCareAttendees",
    "Veterinary Health": "marsVeterinaryHealthAttendees",
  };

  // Empty dependency array to run only once on component mount

  useEffect(() => {
    if (!eventFormData.eventStatus) eventFormData.eventStatus = 'Draft';
  }, [eventFormData.eventStatus]);

  useEffect(() => {
    if (eventFormData.siteCode) {
      setIsEventOffSite(eventFormData.siteCode === "OFF");
      if (eventFormData.siteCode === "OFF")
        fetchAddressCoordinates(eventFormData.eventAddress);
      else
        fetchSiteCoordinates(eventFormData.siteCode);
    }
  }, [eventFormData.siteCode]);

  const loadInitMap = async () => {
    if (!leafLetMap.current) {
      leafLetMap.current = L.map(document.getElementById("MapID"));
      leafLetMap.current.invalidateSize();
    }

    L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);
  }

  const syncSiteFields = async (siteCode,placeIndex) => {
    try {

      const response = await axios.get(`${SITES_BASE_URL}/${siteCode}`);

      // Check if the response contains valid data
      if (response.data) {
        const { latitude, longitude, unit, location, address, country, city } = response.data;

        if (!leafLetMap.current) {
          leafLetMap.current = L.map(document.getElementById("MapID"));
          leafLetMap.current.invalidateSize();
        }

        leafLetMap.current.setView([latitude, longitude], 14);
        L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

        L.Icon.Default.mergeOptions({
          iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
          iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
          shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
        });

        if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
        setMapMarker(null);
        var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
        setMapMarker(marker);

        const tmp = [...eventPlaces]; 
        tmp[placeIndex].eventAddress = address; 
        setEventPlaces(tmp);     
      } else {
        console.error("No data found for the specified site code.");
      }
    } catch (error) {
      console.error("Error fetching site coordinates:", error);
    }
  };

  const fetchSiteCoordinates = async (siteCode) => {
    try {

      const response = await axios.get(`${SITES_BASE_URL}/${siteCode}`);

      // Check if the response contains valid data
      if (response.data) {
        const { latitude, longitude, unit, location, address, country, city } = response.data;

        if (!leafLetMap.current) {
          leafLetMap.current = L.map(document.getElementById("MapID"));
          leafLetMap.current.invalidateSize();
        }

        leafLetMap.current.setView([latitude, longitude], 14);
        L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

        L.Icon.Default.mergeOptions({
          iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
          iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
          shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
        });

        if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
        setMapMarker(null);
        var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
        setMapMarker(marker);

        setEventFormData(prevData => ({
          ...prevData,
          eventVenueName: unit ?? prevData.eventVenueName,
          eventAddress: address ?? prevData.eventAddress,
          countryName: country ?? prevData.countryName,
          stateName: location ?? prevData.stateName,
          cityName: city ?? prevData.cityName,
          mltEvent: storedRole === "MLTUser" ? true : eventFormData.mltEvent
        }));
      } else {
        console.error("No data found for the specified site code.");
      }
    } catch (error) {
      console.error("Error fetching site coordinates:", error);
    }
  };

  const fetchAddressCoordinates = async (address) => {
    const provider = new OpenStreetMapProvider();
    const results = await provider.search({ query: address });
    if (mapMarker) leafLetMap.current.removeLayer(mapMarker);
    setMapMarker(null);
    if (!results[0]) {
      leafLetMap.current.setView([0, 0], 14);
      return;
    }
    const latitude = results[0].y;
    const longitude = results[0].x;

    if (!leafLetMap.current) {
      leafLetMap.current = L.map(document.getElementById("MapID"));
      leafLetMap.current.invalidateSize();
    }

    leafLetMap.current.setView([latitude, longitude], 14);
    L.tileLayer('http://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}').addTo(leafLetMap.current);

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
      iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
      shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
    });

    var marker = L.marker([latitude, longitude]).addTo(leafLetMap.current);
    setMapMarker(marker);
  };

  const rebuildCurrentSiteAddress = () => {
    var address = eventFormData.eventAddress;
    address = address.replace("\n", " ");
    if (eventFormData.eventVenueName) address = eventFormData.eventVenueName + ", " + address;
    if (eventFormData.cityName) address = address + ", " + eventFormData.cityName;
    if (eventFormData.stateName) address = address + ", " + eventFormData.stateName;
    if (eventFormData.countryName) address = address + ", " + eventFormData.countryName;
    return address;
  };

  const handleSearchAddressChange = async (e) => {
    var address = e.target.value;
    setSearchAddress(e.target.value);
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        setSearchAddress(address);
        fetchAddressCoordinates(address);
      }, 500)
    );
  }

  const handleOffSiteChange = async (e) => {
    setIsEventOffSite(e.target.checked);
    if (e.target.checked) {
      var address = searchAddress;
      if (address === "") {
        address = rebuildCurrentSiteAddress();
        setSearchAddress(address);
      }
      fetchAddressCoordinates(address);
    }
    else {
      fetchSiteCoordinates(eventFormData.siteCode);
    }
  };

  const handlePlaceIsExternalChange = async (e,placeIndex) => {
    const tmp = [...eventPlaces]; 
    tmp[placeIndex].isExternal = e.target.checked; 
    if (e.target.checked) {
      if (tmp.externalAddress === "") tmp.externalAddress = rebuildCurrentSiteAddress();
      // fetchAddressCoordinates(tmp.externalAddress);
    }
    else {
      // fetchSiteCoordinates(tmp[placeIndex].siteCode);
    }
    setEventPlaces(tmp);     
  };

  const handlePlaceExternalAddressChange = async (e,placeIndex) => {
    const tmp = [...eventPlaces]; 
    tmp[placeIndex].externalAddress = e.target.value; 
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        setEventPlaces(tmp);     
        fetchAddressCoordinates(tmp[placeIndex].externalAddress);
      }, 500)
    );
  }

  
  const handlePlaceSiteChange = (e,placeIndex) => {
//    handleChange(e);
    //alert(e.target.value);
    const tmp = [...eventPlaces]; 
    tmp[placeIndex].siteCode = e.target.value; 
    setEventPlaces(tmp);     
    syncSiteFields(e.target.value,placeIndex)
//fetchSiteCoordinates(e.target.value);
  };
  
  const handleSiteChange = (e) => {
    handleChange(e);
    fetchSiteCoordinates(e.target.value);
  };

  const handleCapacityChange = (e,idx) => {
     e.preventDefault();
     const caps = requestorCapacities;
//     alert(e.target.value+" "+e.target.checked+" "+idx+JSON.stringify(caps));
     caps[idx] = !caps[idx];//e.target.checked;
     setRequestorCapacities(caps);
     document.getElementById(`capacity-${idx}`).checked = caps[idx];
  };

  const content = (
    <>
      <div className="col-md-6">
        <div className=" bg-light rounded p-3 ">
          <div className="form-group row mb-2">
            <label className="custom-font col-sm-4 col-form-label">CREATED BY</label>
            <div className="col-sm-4 ">
                <input
                    type="text"
                    readOnly={true}
                    className="custom-font-lt form-control-plaintext disabled"
                    value={eventFormData.createdBy || ''}
                    placeholder="Not Applicable"
                    autoComplete="off"
                />
            </div>
          </div>
          <div className="form-group row mb-2">
            <label className="custom-font col-sm-4 col-form-label">REQUESTED BY</label>
            <div className="col-sm-4 ">
                <input
                    type="text"
                    readOnly={true}
                    className="custom-font-lt form-control-plaintext disabled"
                    value={eventFormData.requestedBy || ''}
                    placeholder="Not Applicable"
                    autoComplete="off"
                />
            </div>
            <div className="col-sm-4 ">
            {btnSetReqVisible && (
                <button type="button" id="btnSetRequestor" className="btn btn-outline-primary right-buttons"
                        style={{color:"black", borderColor:"black",fontSize:"8pt"}}
                        onClick={(e) => { e.preventDefault(); setShowReqModal(true); }}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="black" width="16" height="16" viewBox="0 0 24 24" >
                    <path d="M21.7,4.3l-2-2c-0.4-0.4-1-0.4-1.4,0L8,12.6c-0.2,0.2-0.4,0.5-0.5,0.8L6,18c-0.1,0.4,0,0.9,0.3,1.2c0.3,0.3,0.8,0.4,1.2,0.3 l4.6-1.5c0.3-0.1,0.6-0.3,0.8-0.5l10.3-10.3C22.1,5.3,22.1,4.7,21.7,4.3z M8.4,17.2L7.5,16.3l0.7-2.2l5.7-5.7l2,2L8.4,17.2z M18.3,7.3l-2-2l1-1l2,2L18.3,7.3z" />
                    </svg>&nbsp;Set requestor
                </button>
            )}
            <Popup open={showReqModal} onClose={() => {setShowReqModal(false); setUserSearch("");}}
                position="right center"
                arrow={false}
                contentStyle={{ top: '50%', left: '50%', width: '25%', height: '75%' }}
                onOpen={() => document.getElementById("searchUserText").focus() }
            >
             <div className="popup" id="userPopup" style={{ position: 'fixed', top: '50%', left: '50%', width: '25%', height: '75%'}}>
                <div className="container-fluid justify-content-between">
                    <div className="d-flex align-items-center">
                    <a className="navbar-brand mb-0" href="#">
                        <img src={Logo} alt="Logo" width="100" className="d-inline-block align-text-top" />
                    </a>
                    <a
                        className="close-btn"
                        style={{ textDecoration: 'none' }}
                        onClick={(e) => {
                        e.preventDefault();
                        setUserSearch("");
                        setShowReqModal(false); 
                        }}
                    >x</a>
                </div>
                </div>
                    <input style={{ height: 32, width:"100%" }}
                        type="text"
                        id="searchUserText"
                        value={userSearch}
                        onChange={ (e) => {setUserSearch(e.target.value);} }
                        placeholder={"Search any user"}
                    />
                <div className="content" style={{ height: "90%", overflowY: 'scroll'  }}>
                    {familyUsers.map((user) => { if ((user.fullname.toLowerCase().includes(userSearch.toLowerCase())) || (userSearch.toLowerCase()==="")) 
                    return (
                    <div className="guest-item" key={user.id}>
                        <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setEventFormData(prevData => ({ ...prevData, requestedBy: user.fullname, email:user.email }));
                            setNewRequestorId(user.id);
                            setUserSearch("");
                            setShowReqModal(false); 
                        }}
                        >
                        {user.fullname}
                        </a>
                        <br />
                    </div>
                    )})}
                </div>
                </div>
            </Popup>
            </div>
        </div>
        <div className="form-group row mb-2">
            <label className="custom-font col-sm-4 col-form-label">EVENT TITLE</label>
            <div className="col-sm-8 ">
                <input
                    type="text"
                    className={`custom-font-lt form-control`}
                    name="eventTitle"
                    value={eventFormData.eventTitle || ''}
                    onChange={handleChange}
                    placeholder="Title"
                />
                {errors.eventTitle && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventTitle}</div>}
            </div>
        </div>
        <div className="form-group row mb-2 requestorFormDateInterval">
            <label className="custom-font col-sm-4 col-form-label">EVENT DATE</label>
            <div className="col-sm-4">
              <div className="d-flex align-items-center">
                <input
                  type="date"
                  disabled={(eventFormData.eventStatus !== 'Draft')}
                  className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "form-control-custom rounded form-control text-cursor"} 
                  name="eventDate"
                  placeholder={nonEditable ? "" : "Pick event dates"}
                  value={eventFormData.eventDate == '' ? '' : new Date(eventFormData.eventDate).toISOString().split("T")[0]}
                  onChange={handleChange}
                />
                {errors.eventDate && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventDate}</div>}
                <span style={{ margin: '0em 1rem 0em' }}>to</span>
                <input
                  type="date"
                  disabled={(eventFormData.eventStatus !== 'Draft')}
                  className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "form-control-custom rounded form-control text-cursor"} 
                  name="eventEndDate"
                  min={eventFormData.eventDate == '' ? '' : new Date(eventFormData.eventDate).toISOString().split("T")[0]}
                  placeholder={nonEditable ? "" : "Pick event dates"}
                  value={eventFormData.eventEndDate == '' ? '' : new Date(eventFormData.eventEndDate).toISOString().split("T")[0]}
                  onChange={handleChange}
                />
                {errors.eventEndDate && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventEndDate}</div>}
              </div>
            </div>
          </div>
          <div className="form-group row mb-2">
            <label className="custom-font col-sm-4 col-form-label" >EVENT TYPE</label>
            <div className="col-sm-8 " >
              <select 
                disabled={(eventFormData.eventStatus !== 'Draft')}
                className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control form-select form-select-sm"} 
                aria-label="Event type"
                name="eventType"
                value={eventFormData.eventType}
                onChange={handleChange}
              >
                <option value="">Select a Type</option>
                {eventTypeList.map((eventType, index) => (
                  <option key={index} value={eventType}>
                    {eventType}
                  </option>
                ))}
              </select>
              {errors.eventType && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventType}</div>}
            </div>
          </div>
          {(eventFormData.eventType === "Other") && (
            <>
              <div className="form-group row mb-2" id="otherEventTypeDiv">
                <label className="border-custom-strip custom-font col-sm-4 col-form-label">
                  <div className="" />
                  {(eventFormData.eventStatus === 'Draft') ? "PLEASE SPECIFY" : "SPECIFICATION"}
                </label>
                <div className="col-sm-8  ">
                  <input
                    type="text"
                    disabled={(eventFormData.eventStatus !== 'Draft')}
                    className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control"} 
                    name="otherEventType"
                    value={eventFormData.otherEventType}
                    onChange={handleChange}
                  />
                  {errors.otherEventType && <div style={{ color: 'red', fontSize: "13px" }}>{errors.otherEventType}</div>}
                </div>
              </div>
            </>
          )}
          <div className="form-group row mb-2">
            <label
              htmlFor="staticEmail"
              className="custom-font col-sm-4 col-form-label"
            >
              EVENT FORMAT
            </label>
            <div className="col-sm-8 ">
              <select
                disabled={(eventFormData.eventStatus !== 'Draft')}
                className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control form-select form-select-sm"} 
                aria-label="Event format"
                name="eventFormat"
                value={eventFormData.eventFormat}
                onChange={handleChange}
              >
                <option value="">Select an event type format (virtual, in-person, pre-recorded...)</option>
                {eventFormatList.map((eventFormat, index) => (
                  <option key={index} value={eventFormat}>
                    {eventFormat}
                  </option>
                ))}

              </select>
              {errors.eventFormat && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventFormat}</div>}
            </div>
          </div>
          {(eventFormData.eventFormat === "Other") && (
            <>
              <div className="form-group row mb-2" id="otherEventFormatDiv">
                <label
                  htmlFor="staticEmail"
                  className="border-custom-strip custom-font col-sm-4 col-form-label"
                >
                  <div className="" />
                  {(eventFormData.eventStatus === 'Draft') ? "PLEASE SPECIFY" : "SPECIFICATION"}
                </label>
                <div className="col-sm-8  ">
                  <input
                    type="text"
                    disabled={(eventFormData.eventStatus !== 'Draft')}
                    className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control"} 
                    id="staticEmail"
                    name="otherEventFormat"
                    value={eventFormData.otherEventFormat}
                    onChange={handleChange}
                  />
                  {errors.otherEventFormat && <div style={{ color: 'red', fontSize: "13px" }}>{errors.otherEventFormat}</div>}
                </div>
              </div>
            </>
          )}
          <div className="form-group row mb-2">
            <label className="custom-font col-sm-4 col-form-label">RATIONALE</label>
            <textarea
                rows="3"
                placeholder=""
                value={rationale}
                onChange={(e) => { setRationale(e.target.value); } }
                className='form-control popup-textarea'
                style={{marginLeft:"3%", width:"95%"}}
            />
          </div>
          <div className="form-group row mb-2">
            <label className="custom-font col-sm-4 col-form-label">IS ANY PERSONAL TRAVEL PART OF THE TRIP?</label>
            <div className="col-sm-8 " style={{marginTop:"1%"}}>
              <div className="custom-control custom-switch" style={{marginTop:"1%"}}>
                <span className="custom-font-slider-left" style={(eventFormData.eventStatus !== 'Draft') ? {marginLeft:"10px"} : {}}>NO</span>
                <label className="switch">
                    <input type="checkbox" id="isPersonalTravelChk" checked={isPersonalTravel} onChange={(e) => { setIsPersonalTravel(e.target.checked); } }/>
                    <span className="slider round" />
                </label>
                <span className="custom-font-slider-right">YES</span>
              </div>
            </div>
          </div>
            {isPersonalTravel && (
                <div className="form-group">
                    <label className='text-label'>Comment<span style={{ color: "red" }}>*</span></label>
                    <textarea
                        id="idCommentText"
                        rows="3"
                        placeholder=""
                        value={personalTravelComment}
                        onChange={(e) => { setPersonalTravelComment(e.target.value); } }
                        className='form-control popup-textarea'
                    />
                </div>
            )}
          <div className="form-group row mb-2" style={{userSelect:"none"}}>
            <label className="custom-font col-sm-4 col-form-label">IN WHAT CAPACITY ARE YOU MAKING THIS TRIP?</label>
              <div className="col-sm-8" style={{marginTop:"1%"}}>
                  {capacities.map((capacity,rcIndex) => (
                    <div key={capacity+"_"+rcIndex} className="form-check" style={{verticalAlign:"middle"}}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`capacity-${rcIndex}`}
//                        value={rcIndex}
//                        checked={requestorCapacities[rcIndex]}
//                        onChange={(e) => {handleCapacityChange(e,rcIndex);}}
                      /><label className="form-check-label custom-font" htmlFor={`capacity-${rcIndex}`} style={{cursor:"pointer"}}>{capacity}</label>
                    </div>
                  ))}
              </div>
          </div>
        </div>
        <div className="rounded p-3 mt-3" style={{backgroundColor:"#BFD9F2"}}>
            <div className="form-group row mb-2">
              <label className="guest-actions custom-font col-sm-4 col-form-label">EVENT SITES
                <button className={"btn-delete"} onClick={(e) => { e.preventDefault();  const tmp = [...eventPlaces]; tmp.push(eventPlaceDefault); setEventPlaces(tmp);  }} >Add site</button>
              </label>
            </div>
            {eventPlaces.map((eventPlace,placeIndex) => (
              <div key={"Place"+placeIndex} className="form-group row mb-3 bg-light rounded">
                  <div className="form-group row mb-2" style={{marginTop:"2%"}}>
                    <label className="custom-font col-sm-4 col-form-label">EXTERNAL EVENT
                    </label>
                    <div className="col-sm-3">
                      <div className="custom-control custom-switch">
                        <span className="custom-font-slider-left" style={(eventFormData.eventStatus !== 'Draft') ? {marginLeft:"10px"} : {}}>NO</span>
                        <label className="switch">
                          <input type="checkbox" checked={eventPlace.isExternal} onChange={(e) => {handlePlaceIsExternalChange(e,placeIndex);}} disabled={(eventFormData.eventStatus !== 'Draft')} />
                          <span className="slider round" />
                        </label>
                        <span className="custom-font-slider-right">YES</span>
                      </div>
                    </div>
                    {(placeIndex>0) && (<>
                        <div className="col-sm-4"></div>
                        <div className="col-sm-1">
                          <div className="guest-actions"><button className={"btn-delete"} onClick={(e) => { e.preventDefault(); const tmp = [...eventPlaces]; tmp.splice(placeIndex,1); setEventPlaces(tmp); }} ><FaTrash /></button></div>
                        </div>
                        </>
                    )}
                  </div>
                  {(!eventPlace.isExternal) && (
                      <>
                      <div className="form-group row mb-2">
                        <label className="custom-font col-sm-4 col-form-label">AFFILIATED SITE CODE</label>
                        <div className="col-sm-8 " >
                          <select disabled={(eventFormData.eventStatus !== 'Draft')}
                            className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control form-select form-select-sm"} 
                            aria-label="Event status"
                            value={eventPlace.siteCode}
                            onChange={(e)=> {handlePlaceSiteChange(e,placeIndex);}}
                          >
                            <option value="">Select a sitecode</option>
                            {siteData.map((site, index) => (
                                <option key={index} value={site.siteCode}>
                                {site.name}
                                </option>
                            ))}
                          </select>
                          {errors.siteCode && <div style={{ color: 'red', fontSize: "13px" }}>{errors.siteCode}</div>}
                        </div>
                      </div>
                      <div className="form-group row mb-2">
                        <label className="custom-font col-sm-4 col-form-label">EVENT VENUE ADDRESS</label>
                        <div className="col-sm-8 ">
                          <input
                            type="text"
                            className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control disabled"} 
                            id="eventAddress"
                            name="eventAddress"
                            value={eventPlace.eventAddress}
                            disabled={true}
                          />
                        </div>
                      </div>
                      </>
                  )}
                  {(eventPlace.isExternal) && (
                    <>
                      <div className="form-group row mb-2">
                        <label
                          htmlFor="staticEmail"
                          className="custom-font col-sm-4 col-form-label"
                        >
                          EXTERNAL EVENT ADDRESS
                        </label>
                        <div className="col-sm-8 ">
                          <textarea
                            disabled={(!eventPlace.isExternal) || (eventFormData.eventStatus !== 'Draft')}
                            className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control"} 
                            rows="5"
                            value={eventPlace.externalAddress}
                            onChange={(e) => {handlePlaceExternalAddressChange(e,placeIndex);}}
                          />
                          {errors.eventAddress && <div style={{ color: 'red', fontSize: "13px" }}>{errors.eventAddress}</div>}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="form-group row mb-2">
                    <label className="custom-font col-sm-4 col-form-label">ESTIMATED NUMBER OF ATTENDEES</label>
                    <div className="col-sm-8 ">
                      <input
                        type="number" onKeyDown={ (evt) => ((evt.key === 'e') ||(evt.key === 'E') ||(evt.key === '+') || (evt.key === '-') || (evt.key === '.')) && evt.preventDefault() }
                        disabled={(eventFormData.eventStatus !== 'Draft')}
                        className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control"} 
                        id="staticEmail"
                        name="totalAttendees"
                        value={eventPlace.totalAttendees}
                        onChange={handleChange}
                      />
                      {errors.totalAttendees && <div style={{ color: 'red', fontSize: "13px" }}>{errors.totalAttendees}</div>}
                    </div>
                  </div>
              </div>
            ))}
        </div>
        <div className=" bg-light rounded p-3 mt-3">
            <div className="form-group row mb-2">
              <label className="guest-actions custom-font col-sm-4 col-form-label">GUESTS
                <button className={"btn-delete"} onClick={(e) => { e.preventDefault();  const tmp = [...eventPersons]; tmp.push({userId:-1,userFullName:"",personType:"Family"}); setEventPersons(tmp);  }} >Add guest</button>
              </label>
            </div>
            
            {eventPersons.map((eventPerson,personIndex) => (
              <div key={"person"+personIndex} className="form-group row mb-3">
                <div className="col-sm-4">
                  <input type="text" className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control disabled"} 
                    value={eventPerson.userFullName}
                    disabled={personIndex===0}
                  />
                </div>
                <div className="col-sm-4" >
                    <select className={(eventFormData.eventStatus !== 'Draft') ? "custom-font-lt form-control-plaintext disabled" : "custom-font-lt form-control form-select form-select-sm"} aria-label="User subtype"
                            value={eventPerson.personType} 
                            onChange={(e) => { e.preventDefault();  const tmp = [...eventPersons]; tmp[personIndex].personType=e.target.value; setEventPersons(tmp); }}
                            disabled={personIndex===0}>
                    {personIndex===0 && (
                        <option value="Requestor">Requestor</option>
                    )}
                        <option value="Family">Family 18</option>
                        <option value="OtherFamily">Other family</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
                <div className="guest-actions col-sm-2">
                {(personIndex>0) && (eventPerson.personType==="Family") && (
                    <Popup
                      trigger={<div id="btnSearch" className={"btn-delete"} ><FaSearch /></div>}
                      position="right center"
                      arrow={false}>
                      <div className="popup" id="userPopup" style={{ position: 'fixed', top: '50%', left: '50%', width: '25%', height: '75%', overflowY: 'scroll' }}>
                        <div className="container-fluid justify-content-between">
                          <div className="d-flex align-items-center">
                            <a className="navbar-brand mb-0" href="#">
                              <img src={Logo} alt="Logo" width="100" className="d-inline-block align-text-top" />
                            </a>
                            <a
                              className="close-btn"
                              style={{ textDecoration: 'none' }}
                              onClick={(e) => {
                                e.preventDefault();
                                document.getElementById('userPopup').style.display = 'none';
                              }}
                            >
                              �
                            </a>
                          </div>
                        </div>
                        <div className="content" style={{ height: 400 }}>
                          {(familyUsers).map((user) => (
                            <div className="guest-item" key={user.id}>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  const tmp = [...eventPersons]; 
                                  tmp[personIndex].userFullName=user.fullname; 
                                  tmp[personIndex].userId=user.id; 
                                  setEventPersons(tmp);
                                  // alert(JSON.stringify(tmp[personIndex]));
                                  document.getElementById('userPopup').style.display = 'none';
                                }}
                              >
                                {user.fullname}
                              </a>
                              <br />
                            </div>
                          ))}
                        </div>
                      </div>
                    </Popup>
                )}
                {(personIndex>0) && (
                      <button className={"btn-delete"} onClick={(e) => { e.preventDefault(); const tmp = [...eventPersons]; tmp.splice(personIndex,1); setEventPersons(tmp); }} ><FaTrash /></button>
                )}
                    </div>
              </div>
            ))}
          </div>
          <span><br/>Note: Please allow at least 10 business days for the Corporate Secretary and G&NC Chair to review and assess this request.  If this is an urgent request, please contact Stefanie Straub.</span>
      </div>
      <div className="col-md-4 rounded" style={{pointerEvents:"none"}} id="MapID">
        {/* <MapComponent/> */}

      </div>
      <div style={{ height: "100px" }}></div>
    </>
  );

  return content
}
export default FamilyEvent